const show = (btnElement) => {
  btnElement.setAttribute('aria-expanded', true);
  btnElement.nextElementSibling.setAttribute('aria-hidden', false);
  btnElement.parentElement.classList.add('active');
}

const hide = (btnElement) => {
  btnElement.setAttribute('aria-expanded', false);
  btnElement.nextElementSibling.setAttribute('aria-hidden', true);
  btnElement.parentElement.classList.remove('active');
}

const handleClosure = (event) => {
  const $containers = document.querySelectorAll('.js-header-selector');

  [...$containers].forEach((container) => {
    if (!container.contains(event.target)) {
      hide(container.querySelector('.js-header-selector-button'))
    }
  })
}

export default function initHeaderSelectors() {
  const $containers = document.querySelectorAll('.js-header-selector');

  if (!$containers.length) {
    return;
  }
  const isExpanded = (element) => parseAttribute(element, 'aria-expanded');
  const btnsHeaderSelector = document.querySelectorAll('.js-header-selector-button');

  [...btnsHeaderSelector].forEach((btnHeaderSelector) => {
    btnHeaderSelector.addEventListener('click', (event) => {
      event.stopPropagation();
      // eslint-disable-next-line no-unused-expressions
      isExpanded(event.currentTarget) ? hide(event.currentTarget) : show(event.currentTarget);
    })
  });

  const parseAttribute = (element, attribute) => JSON.parse(element.getAttribute(attribute));

  window.addEventListener('click', (event) => handleClosure(event));
  window.addEventListener('focusin', (event) => handleClosure(event));
}

export function initOpenSubmenu() {
  const $containers = document.querySelectorAll('.sub-menu');

  if (!$containers.length) {
    return;
  }

  const btnsSubMenu = document.querySelectorAll('.btn-submenu');

  [...btnsSubMenu].forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.stopPropagation();
      // eslint-disable-next-line no-unused-expressions
      const list = btn.parentElement.classList;
      console.log(list)
      list.toggle('isClose');
    })
  });
}
